import { Component, OnInit, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ProductApiService } from 'src/app/services/api/product-api.service';
import { MessageService } from 'src/app/services/message.service';
import { PlatformDialogTestComponent } from '../../platform/platform-dialog-test/platform-dialog-test.component';

@Component({
  selector: 'app-youtube-recharge-panel',
  templateUrl: './youtube-recharge-panel.component.html',
  styleUrls: ['./youtube-recharge-panel.component.scss'],
})
export class YoutubeRechargePanelComponent implements OnInit {
  @Input() data: any;
  constructor(
    private dialog: MatDialog,
    private router: Router,
    private message: MessageService,
    private api: ProductApiService
  ) {}

  ngOnInit(): void {
    this.getPlatformData();
  }

  loading = false;
  change() {
    if (this.data.ticket_color !== 'normal') {
      return;
    }
    this.dialog.open(PlatformDialogTestComponent, {
      data: Object.assign({}, this.platform, {
        youtube_rechaege_bus_seat_id: this.data.id,
      }),
      autoFocus: false,
      panelClass: 'app-dialog',
    });
  }

  goto(url: string) {
    this.router.navigate([url]);
  }

  platform: any;
  async getPlatformData() {
    try {
      this.loading = true;
      const r = await this.api.getPlatform(3);
      this.platform = r.data;
    } catch (error) {
    } finally {
      this.loading = false;
    }
  }
}
